import { ApInput, ApLoaderDefault, colors } from '@alixpartners/ui-components';
import styled, { css, keyframes } from 'styled-components';

export const SectionsWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: ${colors.grey50};
  padding-top: 32px;
  height: calc(100% - 59px);
  overflow: auto;
  box-sizing: border-box;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
        `
      : ''}
`;

const sectionWidth = '1136px'; // TODO: check if this needs to be 1600px

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(150px);
  }
`;

interface ISectionProps {
  animationIndex: number;
}
export const SectionWrapper = styled.section<ISectionProps>`
  background-color: ${colors.white};
  max-width: ${sectionWidth};
  width: 100%;
  padding: 16px 32px 32px 32px;
  margin: 0 auto 32px;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -2px rgba(0, 0, 0, 0.1);

  animation-name: ${slideIn};
  animation-duration: 600ms;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-delay: ${({ animationIndex }) => `${50 + animationIndex * 75}ms`};
  animation-fill-mode: backwards;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 23px;
  line-height: 28px;
  color: ${colors.grey700};
  height: 44px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  border-bottom: 1px solid ${colors.grey200};
`;

export const ContentBlock = styled.div`
  margin-top: 24px;
  display: flex;
`;

export const Description = styled.div<{ index?: string }>`
  width: 30%;
  max-width: 30%;
  min-width: 30%;
  margin-right: 32px;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey600};
  display: flex;

  ${({ index }) =>
    index
      ? css`
          &::before {
            content: '${index}.';
            display: block;
            font-weight: 600;
            margin-right: 16px;
          }
        `
      : ''}
`;

export const RightSection = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
`;

export const ClientNameInput = styled(ApInput)`
  flex-grow: 1;
`;

interface IInputButtonGroupProps {
  hasErrorMessage?: boolean;
}
export const InputButtonGroup = styled.div<IInputButtonGroupProps>`
  flex-grow: 1;
  display: flex;
  flex-direction: row;

  .ap-button-main {
    margin: 19px 0 0 8px;

    ${({ hasErrorMessage }) =>
      hasErrorMessage
        ? css`
            margin-bottom: 36px;
          `
        : ''}
  }
`;

export const RightSectionColumn = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  margin-right: 30px;

  display: flex;
  flex-direction: column;

  &:last-child {
    margin-right: 0;
  }
`;

export const CostLabel = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  height: 14px;
`;

export const CostValue = styled.div`
  font-weight: 500;
  font-size: 19px;
  line-height: 24px;
  color: ${colors.green600};
  margin-top: 8px;

  a {
    color: ${colors.green600};
    border: 1px solid;
    border-color: ${colors.green700};
    width: fit-content;
  }
`;

export const CostSectionWrapper = styled(SectionWrapper)`
  ${RightSectionColumn}:last-child {
    box-sizing: border-box;
    padding-top: 3px;

    .ap-button-secondary {
      max-width: 118px;
    }
  }

  ${ContentBlock}:last-child ${InputButtonGroup} {
    div:first-child {
      max-width: 202px;
    }
  }
`;

export const Loading = styled(ApLoaderDefault)`
  margin-top: 200px;
`;
